import React, { FC, useEffect, useMemo, useState } from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import SectionSliderBlog from "components/SectionSliderNewCategories/SectionSliderBlog";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionGridHasMap from "./SectionGridHasMap";
import { Helmet } from "react-helmet";
import useQuery from "hooks/useQuery";
import { useFetch, useSearch } from "hooks/useFetch";
import { BorderCoor } from "types/map";
import { IBlog } from "types/blog";
import { RentripsURL } from "utils/request";

export interface ListingCarMapPageProps {
  className?: string;
}

const ListingCarMapPage: FC<ListingCarMapPageProps> = ({ className = "" }) => {
  // eslint-disable-next-line
  const { result, name } = useQuery();
  const [borderCoor, setBorderCoor] = useState<BorderCoor | null>(null);
  const q = useMemo(() => {
    if (borderCoor) {
      return `&n=${borderCoor?.ne.lat || ""}&e=${borderCoor?.ne.lng || ""}&s=${
        borderCoor?.sw.lat || ""
      }&w=${borderCoor?.sw.lng || ""}`;
    } else {
      return "";
    }
  }, [borderCoor]);

  const { data: blogs } = useFetch<Array<IBlog>>(RentripsURL +"/api/blog/");
  const [data, loading] = useSearch(result + q);

  const renderBlogSection = () => {
    return (
      <div className="relative py-16">
        <BackgroundSection />
        <SectionSliderBlog
          heading="Artikel - artikel menarik"
          subHeading="Baca artikel menarik lainnya seputar keperluan travelling"
          categoryCardType="card4"
          itemPerRow={5}
          sliderStyle="style2"
          blogs={blogs}
        />
      </div>
    );
  };

  useEffect(() => {
    if (!name) {
      window.location.href = "/map?location=denpasar-selatan";
    }
  }, [name]);

  return (
    <div
      className={`nc-ListingCarMapPage relative ${className}`}
      data-nc-id="ListingCarMapPage"
    >
      <Helmet>
        <title>
          Sewa barang di{" "}
          {name ? name?.charAt(0).toUpperCase() + name?.slice(1) : "Bali"}
        </title>
        <meta
          name="description"
          content={`Sewa barang keperluan camping di ${
            name ? name?.charAt(0).toUpperCase() + name?.slice(1) : "Bali"
          } sekarang, barang sewa dengan kualitas terbaik dan harga terjangkau. Dapatkan berbagai promo menarik. Sewa barang, ya Rentrips.id aja`}
        />
      </Helmet>
      <BgGlassmorphism />

      {/* SECTION HERO */}
      {/* <div className="container pt-10 pb-24 lg:pt-28 lg:pb-32">
        <SectionHeroArchivePage
          currentPage="Rental car"
          currentTab="Rental car"
          listingType={
            <>
              <i className="text-2xl las la-car"></i>
              <span className="ml-2.5">1512 cars</span>
            </>
          }
        />
      </div> */}

      {/* SECTION */}
      <div className="container pb-24 lg:py-28 2xl:pl-10 xl:pr-0 xl:max-w-none">
        <SectionGridHasMap
          loading={loading}
          location={name as string}
          data={data}
          onChange={(coor) => {
            // borderCoor.current = coor;
            setBorderCoor(coor);
          }}
        />
      </div>

      <div className="container overflow-hidden">
        {/* SECTION 1 */}
        {blogs && blogs.length > 0 && renderBlogSection()}

        {/* SECTION */}
        <SectionSubscribe2 className="py-24 lg:py-32" />

        {/* SECTION */}
        {/* <div className="relative py-16 mb-24 lg:mb-32">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <SectionGridAuthorBox />
        </div> */}
      </div>
    </div>
  );
};

export default ListingCarMapPage;
